/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AddTagsAndSubscriptionsRequest } from '../model/addTagsAndSubscriptionsRequest';
import { CreateClientAndBulkSubscriptionsRequest } from '../model/createClientAndBulkSubscriptionsRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ManagementBulkClientProcessControllerService {

    protected basePath = 'https://client.sette-services.inellipse.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createClientSubscriptionsBulk(body: CreateClientAndBulkSubscriptionsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public createClientSubscriptionsBulk(body: CreateClientAndBulkSubscriptionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public createClientSubscriptionsBulk(body: CreateClientAndBulkSubscriptionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public createClientSubscriptionsBulk(body: CreateClientAndBulkSubscriptionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createClientSubscriptionsBulk.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/v1/management/clients/subscriptions/bulk-process`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Supplements an already-existing client with tags and subscriptions - never creates a
     * new client, unlike createClientSubscriptionsBulk above.
     * @param clientId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTagsAndSubscriptionsToClient(clientId: string, body: AddTagsAndSubscriptionsRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addTagsAndSubscriptionsToClient(clientId: string, body: AddTagsAndSubscriptionsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addTagsAndSubscriptionsToClient(clientId: string, body: AddTagsAndSubscriptionsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addTagsAndSubscriptionsToClient(clientId: string, body: AddTagsAndSubscriptionsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling addTagsAndSubscriptionsToClient.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling addTagsAndSubscriptionsToClient.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/v1/management/clients/subscriptions/${encodeURIComponent(String(clientId))}/bulk-process`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
